import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const iconBadgeFn = /* @__PURE__ */ createRecipe('IconBadge', {
  "size": "md",
  "palette": "neutral"
}, [])

const iconBadgeVariantMap = {
  "size": [
    "sm",
    "md"
  ],
  "palette": [
    "primary",
    "secondary",
    "ghost",
    "subtle",
    "accent",
    "danger",
    "warning",
    "success",
    "mastering",
    "samples",
    "plugins",
    "collaboration",
    "extras",
    "courses",
    "distribution",
    "synchroArts",
    "neutral"
  ]
}

const iconBadgeVariantKeys = Object.keys(iconBadgeVariantMap)

export const iconBadge = /* @__PURE__ */ Object.assign(memo(iconBadgeFn.recipeFn), {
  __recipe__: true,
  __name__: 'iconBadge',
  __getCompoundVariantCss__: iconBadgeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: iconBadgeVariantKeys,
  variantMap: iconBadgeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, iconBadgeVariantKeys)
  },
  getVariantProps: iconBadgeFn.getVariantProps,
})